import { render, staticRenderFns } from "./ProjectVariables.vue?vue&type=template&id=085c30ae&scoped=true&"
import script from "./ProjectVariables.vue?vue&type=script&lang=js&"
export * from "./ProjectVariables.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVariables.vue?vue&type=style&index=0&id=085c30ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c30ae",
  null
  
)

export default component.exports